/**
 * CSVエクスポートユーティリティ
 * BOM付きUTF-8で出力（Excel日本語対応）
 */

interface CsvColumn<T> {
  key: keyof T | string;
  label: string;
  format?: (row: T) => string;
}

export function exportCsv<T extends Record<string, unknown>>(
  filename: string,
  columns: CsvColumn<T>[],
  rows: T[],
) {
  // ヘッダー行
  const header = columns.map((c) => escapeCsvField(c.label)).join(',');

  // データ行
  const dataRows = rows.map((row) =>
    columns
      .map((col) => {
        if (col.format) return escapeCsvField(col.format(row));
        const val = row[col.key as keyof T];
        return escapeCsvField(val == null ? '' : String(val));
      })
      .join(','),
  );

  // BOM + CSV文字列
  const bom = '\uFEFF';
  const csvContent = bom + [header, ...dataRows].join('\r\n');

  // Blobでダウンロード
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeCsvField(value: string): string {
  // ダブルクォートを含む場合、またはカンマ・改行を含む場合はクォートで囲む
  if (value.includes('"') || value.includes(',') || value.includes('\n') || value.includes('\r')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}
